import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth-service';
import { PathResolveService } from 'src/app/services/path-resolve.service';

@Component({
  selector: 'app-organization-admin',
  templateUrl: './organization-admin.component.html',
  styleUrls: ['./organization-admin.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganizationAdminComponent {
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  protected readonly organizationPath = PathResolveService.getOrganizationAdminOrganizationPath();
  protected readonly usersPath = PathResolveService.getOrganizationAdminUsersPath();
  protected readonly groupsPath = PathResolveService.getOrganizationAdminGroupsPath();

  constructor() {
    this.authService.claimsReloaded$.pipe(takeUntilDestroyed()).subscribe(() => {
      if (!this.authService.canManageOrganization()) {
        this.router.navigate([PathResolveService.getCockpitPath()]);
      }
    });
  }
}
